import { makeStyles } from '@mui/styles'
import { Colors } from 'theme/colors'
import { theme } from 'theme/theme'

export const useStyles = makeStyles({
  card: {
    [theme.breakpoints.down('sm')]: {
      minWidth: 'auto',
    },
    width: '100%',
  },

  field: {
    marginRight: theme.spacing(),
    marginTop: theme.spacing(),
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
      width: '100%',
    },
  },

  actions: {
    display: 'flex',
    flexDirection: 'row-reverse',
    flexWrap: 'wrap-reverse',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse',
    },
  },

  button: {
    margin: theme.spacing(1),
  },

  secondaryButton: {
    margin: theme.spacing(1),
    color: Colors.neutrals[4],
  },

  cardHeader: {},
})
